// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-checklist2-report-widget-details .widget-details-wrapper,
.fi-checklist2-report-widget-details .checklist-report-details {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/checklist/fi-checklist2-report/components/widget-details/fi-checklist2-report-widget-details.component.scss"],"names":[],"mappings":"AACI;;EAEI,YAAA;AAAR","sourcesContent":[".fi-checklist2-report-widget-details {\r\n    .widget-details-wrapper,\r\n    .checklist-report-details {\r\n        height: 100%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
